import { actions } from 'react-redux-form';
import { httpPost, httpDownload, httpGet } from '../../../../utils/api.utils';
import { convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';
import {
    setDefaultArticleCatalogue
    , setArticleCatalogueError
    , getArticleCatalogue
    , sortArticleCatalogueItems
    , setArticleCatalogueColSearchStr
    , setArticleCataloguePageSize
    , setArticleCatalogueFilter
    , applyArticleCatalogueFilter
} from '../../../../constants/model-reducers/external/recharge/article-catalogue/article-catalogue.settings';

import {
    DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE
} from '../../../../constants/external-constants';

const defaulState = () => ({
    articleCatalogueIsSortedAsc: true
    , articleCatalogueColSort: ''
    , articleCatalogueTableFilterList: []
    , articleCatalogueTableFilterApply: false
    , isArticleCatalogueLoaded: false
    , isArticleCatalogueError: false
    , articleCatalogueItems: DEFAULT_TABLE_RESULT_MODEL
});

const initialState = defaulState();

export const articleCatalogueActions = {
    setDefaultArticleCatalogue: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultArticleCatalogue,
            articleCatalogueItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },

    getArticleCatalogue: (pageIndex = 0) => async (dispatch, state) => {
        const { Headers, Pagination } = state().articleCatalogue.articleCatalogueItems;
        const {
            articleCatalogueIsSortedAsc,
            articleCatalogueColSort,
            articleCatalogueTableFilterList,
            articleCatalogueTableFilterApply } = state().articleCatalogue;

        try {
            var data = {
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: sessionStorage.getItem('UserID'),
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: articleCatalogueColSort,
                IsSortAscending: articleCatalogueIsSortedAsc,
                TableFilterList: articleCatalogueTableFilterList,
                ApplyFilter: articleCatalogueTableFilterApply,
            };
            var articleCatalogueItems = await httpPost('external/recharge/getArticleCatalogueItems', data);
            dispatch({
                type: getArticleCatalogue,
                articleCatalogueItems: Object.keys(articleCatalogueItems).length > 0 ? articleCatalogueItems : DEFAULT_TABLE_RESULT_MODEL,
                isArticleCatalogueLoaded: true,
                isArticleCatalogueError: false
            });
        }
        catch (e) {
            dispatch({
                type: setDefaultArticleCatalogue,
                isArticleCatalogueError: true,
                isArticleCatalogueLoaded: false
            });
        }
    },

    sortArticleCatalogue: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().articleCatalogue.articleCatalogueItems.Pagination;
        const {
            articleCatalogueTableFilterList
            , articleCatalogueTableFilterApply
            , articleCatalogueItems } = state().articleCatalogue;

       
            var data = {
                PageFilter: {
                    PageIndex: PageNumber !== undefined ? PageNumber : 0,
                    PageSize: articleCatalogueItems.Pagination.PerPage,
                    PageSizes: PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: sessionStorage.getItem('UserID'),
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...articleCatalogueItems.Headers
                },
                SortedColumnName: columnClicked,
                IsSortAscending: isSortedAsc,
                TableFilterList: articleCatalogueTableFilterList,
                ApplyFilter: articleCatalogueTableFilterApply,
            };

            var result = await httpPost('external/recharge/getArticleCatalogueItems', data);

        if (result.ok === false) {
            dispatch({
                type: setArticleCatalogueError,
                isArticleCatalogueError: true,
                isArticleCatalogueLoaded: false
            });
        } else {
            dispatch({
                type: sortArticleCatalogueItems,
                articleCatalogueItems: Object.keys(result).length > 0 ? result : DEFAULT_TABLE_RESULT_MODEL,
                articleCatalogueColSort: columnClicked,
                articleCatalogueIsSortedAsc: isSortedAsc,
                isArticleCatalogueLoaded: true
            });
        }
    },

    setArticleCatalogueColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { articleCatalogueItems } = state().articleCatalogue;
        var articleCatalogueItemsUpd = {
            ...articleCatalogueItems,
            "Headers": {
                ...articleCatalogueItems.Headers,
                [key]: {
                    ...articleCatalogueItems.Headers[key],
                    searchString: val
                }
            }
        }
        dispatch({
            type: setArticleCatalogueColSearchStr,
            data: articleCatalogueItemsUpd,
            isArticleCatalogueError: false,
            isArticleCatalogueLoaded: true
        });
    },

    resizeArticleCataloguePage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setArticleCataloguePageSize,
            pageSize: parseInt(pageSize),
        });
    },

    addArticleCatalogueFilter: (tableFilter) => (dispatch, state) => {
        const { articleCatalogueTableFilterList } = state().articleCatalogue;
        var filterList = [...articleCatalogueTableFilterList, tableFilter];
        dispatch({
            type: setArticleCatalogueFilter,
            filterList: filterList
        })
    },

    removeArticleCatalogueFilter: (removeIndex) => (dispatch, state) => {
        const { articleCatalogueTableFilterList } = state().articleCatalogue;
        var filterList = articleCatalogueTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });
        dispatch({
            type: setArticleCatalogueFilter,
            filterList: filterList
        })
    },

    applyArticleCatalogueFilter: (isApply) => (dispatch, state) => {
        const { articleCatalogueTableFilterList } = state().articleCatalogue;
        dispatch({
            type: applyArticleCatalogueFilter,
            applyFilter: isApply,
            filterList: isApply ? articleCatalogueTableFilterList : []
        });
    },

    saveArticleCatalogueCustomCols: (selectedCols) => async (dispatch, state) => {
            const { Headers, Pagination } = state().articleCatalogue.articleCatalogueItems;
            const { articleCatalogueColSort, articleCatalogueIsSortedAsc } = state().articleCatalogue;
    
            try {
                var userId = sessionStorage.getItem('UserID');
    
                var customizeFormData = {
                    UserId: parseInt(userId),
                    ReportColumnModule: REPORT_COLUMN_MODULE.ArticleCatalogueRechargeManagement,
                    SelectedCols: selectedCols
                };
    
                await httpPost('external/recharge/saveArticleCatalogueCustomizeColumns', customizeFormData)
                dispatch({
                    type: setArticleCatalogueError,
                    isArticleCatalogueError: false,
                    isArticleCatalogueLoaded: false
                });
    
                var data = {
                    PageFilter: {
                        PageIndex: 0,
                        PageSize: Pagination.PerPage,
                        PageSizes: Pagination.PageSizes
                    },
                    Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                    UserId: userId,
                    EmployeeId: sessionStorage.getItem('EmployeeID'),
                    Headers: {
                        ...Headers
                    },
                    SortedColumnName: articleCatalogueColSort,
                    IsSortAscending: articleCatalogueIsSortedAsc
                };
    
                var articleCatalogueItems = await httpPost('external/recharge/getArticleCatalogueItems', data);
    
                dispatch({
                    type: getArticleCatalogue,
                    articleCatalogueItems: Object.keys(articleCatalogueItems).length > 0 ? articleCatalogueItems : DEFAULT_TABLE_RESULT_MODEL,
                    isArticleCatalogueLoaded: true,
                    isArticleCatalogueError: false
                });
            }
            catch (e) {
                dispatch({
                    type: setArticleCatalogueError,
                    isArticleCatalogueError: true,
                    isArticleCatalogueLoaded: false
                });
            }
        },
    
        extractArticleCatalogue: () => async (dispatch, state) => {
        const { Headers } = state().articleCatalogue.articleCatalogueItems;
        const { articleCatalogueColSort, articleCatalogueIsSortedAsc, articleCatalogueTableFilterList, articleCatalogueTableFilterApply } = state().articleCatalogue;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        const filename = `ATEM ${dealName} Article Extract - ${formattedTimeZoneDate}`;
        
        let isComponentHeaderHidden = Headers?.Components?.hidden
        
        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: articleCatalogueColSort,
            IsSortAscending: articleCatalogueIsSortedAsc,
            TableFilterList: articleCatalogueTableFilterList,
            ApplyFilter: articleCatalogueTableFilterApply,
            isComponentHidden: isComponentHeaderHidden
    
        };
    
        httpDownload('external/recharge/getAllArticleCatalogueExtractItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getArticleCatalogue:
            return {
                ...state
                , articleCatalogueItems: action.articleCatalogueItems
                , isArticleCatalogueLoaded: action.isArticleCatalogueLoaded
                , isArticleCatalogueError: action.isArticleCatalogueError
            };
        case sortArticleCatalogueItems:
            return {
                ...state
                , articleCatalogueItems: action.articleCatalogueItems
                , articleCatalogueColSort: action.articleCatalogueColSort
                , articleCatalogueIsSortedAsc: action.articleCatalogueIsSortedAsc
                , isArticleCatalogueLoaded: action.isArticleCatalogueLoaded
            }
        case setArticleCatalogueColSearchStr:
            return {
                ...state
                , articleCatalogueItems: action.data
                , isArticleCatalogueLoaded: action.isArticleCatalogueLoaded
                , isArticleCatalogueError: action.isArticleCatalogueError
            }
        case setArticleCataloguePageSize:
            return {
                ...state
                , articleCatalogueItems: {
                    ...state.articleCatalogueItems
                    , Pagination: {
                        ...state.articleCatalogueItems.Pagination
                        , PerPage: action.pageSize
                    }
                }
            }
        case setArticleCatalogueFilter:
            return {
                ...state,
                articleCatalogueTableFilterList: action.filterList
            }
        case applyArticleCatalogueFilter:
            return {
                ...state,
                articleCatalogueTableFilterApply: action.applyFilter,
                articleCatalogueTableFilterList: action.filterList
            }
        case setDefaultArticleCatalogue:
            return initialState;
        default:
            return state;
    }
}